import React from 'react';
import { FormatComponentProps } from './types';

const LatexFormulaBlock: React.FC<FormatComponentProps> = ({ content, formulaSelected }) => {
  // Remove the \[ and \] delimiters
  const formulaContent = content.replace(/^\\\[\s*|\s*\\\]$/g, '');

  // Process the formula content
  let processedFormula = formulaContent.replace(/\\times/g, '*');

  // Make bracketed terms bold
  processedFormula = processedFormula.replace(/\[([^\]]+)\]/g, (_, term) => {
    return `<strong>${term}</strong>`;
  });

  return (
    <div className="formula-block">
      <span
        style={{ padding: '4px', cursor: 'pointer' }}
        onClick={() => formulaSelected?.(formulaContent)}
        dangerouslySetInnerHTML={{ __html: processedFormula }}
      />
    </div>
  );
};

export default LatexFormulaBlock;
